import { reactLocalStorage } from 'reactjs-localstorage';
import { Action, Confirm } from 'helper/Alert';
import { getUserInfo } from 'helper/LocalStorage';
import { adminUrl } from "../config/config.js";
import moment from 'moment';
import { toastMessage } from 'components/Toast/Toast.js';
import { isMerchant } from 'helper/Admin.js';
import { getUrlCourtId } from 'helper/Court.js';

const Axios = require('axios');

export const getToken = () => {
  let token = ''
  if (reactLocalStorage.get('user_token')) {
    token = reactLocalStorage.get('user_token');
  }
  // if (!token) {
  //   reactLocalStorage.clear()
  //   window.location.href = "/login"
  // }
  return token;
}
const setMerchant = () => {
  let merchantId = isMerchant()
  if (merchantId) { return { 'merchant-id': merchantId } }
  return {}
}

const setPlace = () => {
  let placeId = getUrlCourtId()
  if (placeId) { return { 'place-id': placeId }}
  return {}
}

export const client = Axios.create({
  baseURL: adminUrl,
  // access: getMAC('en0'),
  headers: {
    'Content-Type': 'application/json',
    ...setMerchant(),
    'x-access-token': getToken(),
    ...setPlace()
  },
  timeout: 10000,
});

export const errorValidation = (e) => {
  try {
    if (e.response.status === 405) {
      // deleteUserInfo()
      localStorage.clear()
      reactLocalStorage.clear()
      Action("", "Uh oh .. you are logged out because of multiple login. Please login again.", () => {
        window.location.href = "/login"
      })
    }
    if (e.response.status === 403) {
      // deleteUserInfo()
    }
    console.log('here error', e.response)
    return { error: e.response.data.message || e.response.data.status };
  } catch (error) {
    console.log('here error', error)
    toastMessage("There is problem with server connection", {
      toastId: "error-api",
      type: "error"
    });
    return { error: 'There is problem with server connection' }
  }
}

export const FormatServerDate = (date) => {
  // 2024-07-14T16:00:00.000Z
  if (!date) { return null }
  let splitDate = date.split('T')
  console.log('here check date information', splitDate, moment(splitDate[0]).format('YYYY-MM-DD'), moment(splitDate[0]).format('YYYY-MM-DDT17:00:00.000'))
  return moment(splitDate[0]).add(-1, 'day').format('YYYY-MM-DDT17:00:00.000')
}

// export const login = async function (body) {
//   try {
//     let response = await client.post('/login', {
//       phoneNumber: body.phoneNumber || ""
//     });
//     if (response.data.statusCode !== 200) { throw response.data.data; }
//     let data = response.data.data;
//     return { data };
//   } catch (e) {
//     return { error: e.response.data.errorCode };
//   }
// }

// export const registerUser = async function(body) {
//   try {
//     let response = await client.post(`/register-user/${body._id}`, {
//       name: body.name || "",
//       phoneNumber: body.phoneNumber || "",
//       gender: body.gender || "", // Male
//     });
//     if (response.data.statusCode !== 200) { throw response.data.data; }
//     let data = response.data.data;
//     return { data };
//   } catch (e) {
//     return { error: e.response.data.errorCode };
//   }
// };

